import React from 'react';
import SelectHour from './SelectHour';
import { formatDate } from '../../../../../utils/date';

function HourPickerModal(props) {
	return (
		<div className="picked-hour-and-buttons-container">
			<div className="prev-and-picked-date">
				<div
					className="prev-icon-container"
					onClick={() => props?.setShowHour(false)}
				>
					<span className="prev-icon"></span>
					<span className="prev-title">Retour</span>
				</div>
				<span className="picked-date">
					{formatDate(props?.selectedDate, 'DD MMMM YYYY')}
				</span>
			</div>
			<div className="picked-hour-container">
				<SelectHour
					isoDate={props?.selectedDate}
					setSelectedDate={(date) => props?.setSelectedDate(date)}
					rdvs={props?.rdvs}
				/>
			</div>
			<div className="pick-date-buttons-container">
				<div className="button-validate" onClick={() => props?.saveRdv()}>
					Valider cet horaire
				</div>
				<div
					className="button-previous"
					onClick={() => props?.setShowHour(false)}
				>
					Retour
				</div>
			</div>
		</div>
	);
}

export default HourPickerModal;
